// Versions du bundle CGU + politique de confidentialité. DEUX numéros, parce que DEUX rôles.
//
// Un seul `TERMS_VERSION` les portait jusqu'au 24/09/2026 : il identifiait le document ET imposait
// un mur de re-consentement à toute la base installée. Corriger une coquille des CGU n'avait donc
// aucun chemin — soit on la laissait, soit on bloquait tout le monde pour une virgule.

// Ce qui est AFFICHÉ. Égale au littéral « Version X.Y » de TermsScreen et PrivacyScreen (un test
// le vérifie ; `buildLegalDocs.js` lit ce littéral dans le source, il ne peut pas venir d'ici).
// Se bumpe à CHAQUE révision, même de forme.
export const VERSION_DOCUMENTS = '1.12';

// Ce dont l'ACCEPTATION est exigée. Le gate la compare à `profiles.terms_version` et impose
// AcceptTermsScreen à toute la base quand elles diffèrent (§12 de la politique). Se bumpe
// SEULEMENT quand le fond change ; une révision de forme informe sans rouvrir le mur.
// Ne dépasse jamais VERSION_DOCUMENTS : on n'accepte pas un document qui n'existe pas.
export const VERSION_CONSENTEMENT = '1.7';
